import { Injectable } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, throwError } from 'rxjs';
import { MyAccountService } from "@app/core/my-account.service";

export type MainInfo = {
    organizationsCount: number;
};

@Injectable()
export class MainInfoResolver {
    constructor(
        private _myAccountService: MyAccountService,
    ) { }

    resolve: ResolveFn<MainInfo> = (route, state) => {
        return this._myAccountService.getOrganizationsCount().pipe(
            map(count => ({
                organizationsCount: count,
            })),
        );
    }
}
